import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const Referral = () => import("../components/content/referrals/referral");
const Referralpage = () =>
  import("../components/content/referrals/referralPage");

export const referralRoutes = {
  path: "/referral",
  component: Referral,
  children: [
    {
      path: "",
      component: Referralpage
    }
  ],
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
